import React from 'react';
import { Container } from 'react-bootstrap';
import { resetCookieConsentValue } from 'react-cookie-consent';

//  Constants
import { COOKIE_NAME, DOMAIN } from '../../data/constants';

//  Styles
import './CookiesPolicy.scss';

const CookiesPolicy = () => {
	const resetCookieConsent = name => {
		resetCookieConsentValue(name);
	};

	return (
		<>
			<section className="title">
				<Container className="py-4">
					<h1>Cookies Policy</h1>
				</Container>
			</section>
			<section className="atualizacao">
				<Container>
					<p className="text-muted">
						<b>Last update: </b>16/12/2021
					</p>
				</Container>
			</section>
			<section className="artigo">
				<Container>
					<section className="intro">
						<h3 className="text-uppercase">Introduction</h3>
						<p>
							This Cookie Policy explains what cookies are and how
							I use them, the types of cookies I use, i.e, the
							information that I collect using cookies and how
							this information is used, and how to control your
							cookie preferences. For more information about how I
							use, store, and keep your personal information
							secure personal data, please see my Privacy Policy.
						</p>
						<p>
							You may, at any time, change or withdraw your your
							consent to the Cookie Statement on the website.
							Learn more about who I am, how you can contact me,
							and how I process personal data in my Privacy
							Policy. Your consent applies to the following
							domains: {DOMAIN}
						</p>

						<p
							className="text-danger"
							role="button"
							onClick={() => {
								resetCookieConsent(COOKIE_NAME);
							}}>
							👉 Reset consent
						</p>
					</section>
					<br />
					<section className="ser">
						<h3 className="text-uppercase">
							What are Cookies ? 🍪
						</h3>
						<p>
							Cookies are small text files that are used to store
							small pieces of information. They are saved on your
							device when the site is loaded in your browser.
							These Cookies help make the site work better, make
							it more secure provide a better user experience, and
							understand how the site works and to analyze what
							works and where it needs improvement.
						</p>
					</section>
					<br />
					<section className="uso">
						<h3 className="text-uppercase">
							How do I use Cookies ? 🔍
						</h3>
						<p>
							Like most online services, my site uses first-party
							and third-party cookies for various purposes.
							First-party cookies are primarily necessary for the
							proper functioning of the site and do not collect
							any of your personally identifiable information.
						</p>
						<p>
							The third party cookies used on my site are
							primarily to understand how the site works, how you
							interact with our site, to keep my services secure,
							to provide advertisements that are relevant to you
							and, in short, to provide you with a better user
							experience and help streamline your future
							interactions with my site.
						</p>
					</section>
					<br />
					<section className="controlo">
						<h3 className="text-uppercase">
							How can I control Cookie preferences ? 🛂
						</h3>
						<p>
							You can decide to change your preferences later
							through your browser session, you can click on
							"Cookies" in the footer of the website. Now on the
							Cookies Policy page, in the introduction you will
							have the opportunity to click on "Reset consent"
							which will reset your choice and then you have to
							refresh the page.
						</p>
					</section>
					<br />
				</Container>
			</section>
		</>
	);
};

export default CookiesPolicy;
